/**
 * Product Timers - Random values for sold count and stock urgency
 * 
 * This script handles:
 * 1. Sold Timer: Generates random sold count and hours
 * 2. Stock Bar: Generates random stock count and animates progress bar
 */

(function() {
  'use strict';

  /**
   * Generate a random integer between min and max (inclusive)
   */
  function randomInt(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  /**
   * Get or generate a cached random value for a product
   * Values are cached in sessionStorage to stay consistent during session
   */
  function getCachedValue(key, productId, min, max) {
    const storageKey = `product_timer_${key}_${productId}`;
    let value = sessionStorage.getItem(storageKey);
    
    if (value === null) {
      value = randomInt(min, max);
      sessionStorage.setItem(storageKey, value);
    }
    
    return parseInt(value, 10);
  }

  /**
   * Initialize Sold Timers
   */
  function initSoldTimers() {
    const timers = document.querySelectorAll('[data-sold-timer]');
    
    timers.forEach(function(timer) {
      try {
        const config = JSON.parse(timer.getAttribute('data-sold-timer'));
        const soldEl = timer.querySelector('[data-sold]');
        const hourEl = timer.querySelector('[data-hour]');
        
        if (soldEl && config.mins && config.maxs) {
          const soldCount = getCachedValue('sold', config.id, config.mins, config.maxs);
          soldEl.textContent = soldCount;
        }
        
        if (hourEl && config.mint && config.maxt) {
          const hours = getCachedValue('hours', config.id, config.mint, config.maxt);
          hourEl.textContent = hours;
        }
      } catch (e) {
        console.error('Error initializing sold timer:', e);
      }
    });
  }

  /**
   * Initialize Stock Bars
   */
  function initStockBars() {
    const bars = document.querySelectorAll('[data-stock-bar]');
    
    bars.forEach(function(bar) {
      try {
        const config = JSON.parse(bar.getAttribute('data-stock-bar'));
        const countEl = bar.querySelector('[data-stock-count]');
        const progressEl = bar.querySelector('[data-progress-bar]');
        
        if (countEl && config.min && config.max) {
          const stockCount = getCachedValue('stock', config.id, config.min, config.max);
          countEl.textContent = stockCount;
          
          // Calculate and animate progress bar
          if (progressEl && config.total) {
            const soldPercent = ((config.total - stockCount) / config.total) * 100;
            const clampedPercent = Math.min(95, Math.max(5, soldPercent));
            
            // Animate the progress bar
            setTimeout(function() {
              progressEl.style.width = clampedPercent + '%';
            }, 100);
          }
        }
      } catch (e) {
        console.error('Error initializing stock bar:', e);
      }
    });
  }

  /**
   * Initialize all timers
   */
  function init() {
    initSoldTimers();
    initStockBars();
  }

  // Run on DOMContentLoaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Also run on section:load for Shopify theme editor
  document.addEventListener('shopify:section:load', init);
})();
